import styled from '@emotion/styled';
import { rem, rgba } from '@utils';

const Wrapper = styled.div`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(14)};
  padding: 0 ${rem(16)};
  z-index: 1;
`;

const Header = styled.h1`
  font-size: ${rem(20)};
  font-weight: 600;
  margin: ${rem(32)} 0 ${rem(14)};
`;

const Text = styled.p`
  margin-bottom: ${rem(24)};
`;

const ErrorMessage = styled.code`
  background: ${({ theme }) => rgba(theme.palette.pink.medium, 0.2)};
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.pink.medium};
  display: block;
  font-size: ${rem(10)};
  font-style: italic;
  font-weight: 500;
  line-height: ${rem(14)};
  max-width: 768px;
  padding: ${rem(16)};

  @media (max-width: 430px) {
    display: none;
  }
`;

const ErrorTitle = styled.h2`
  font-size: ${rem(12)};
  font-style: normal;
  font-weight: 600;
  margin-bottom: ${rem(8)};
`;

export default {
  Wrapper,
  Header,
  ErrorMessage,
  ErrorTitle,
  Text
};
